import { useState } from 'react'
import { FAQItem } from '../../../components/ui-components/FAQItem'

const familyFAQs = [
  {
    title: 'Who can I add as a family member?',
    descp: `You can add your spouse, parents, children, siblings, or even someone outside the family whose investments you manage.`
  },
  {
    title: 'Can I buy Elite for my family members?',
    descp:
      'Yes. As an Elite member, you can buy Elite for any of your family members at a special price of ₹749 for a yearly membership.'
  },
  {
    title: 'Will they get all the Elite benefits?',
    descp: `Yes, your family member will then receive all Elite benefits including:
      <ul style="list-style-type: disc; padding-left: 20px;">
      <li>Power Rank</li>
      <li>Elite Scores</li>
      <li>Rank Trends</li>
      <li>Power Rebalancing</li>
      <li>Regular to Direct Plan</li>
      <li>Tax-Saving Plan</li>
      </ul>`
  },
  {
    title: 'Will their Elite membership be affected if my membership expires?',
    descp:
      'No, their membership will not be affected. Once purchased, it runs independently and continues even if your own Elite expires.'
  }
]

export const FamilyFAQs = () => {
  const [accordionState, setAccordionState] = useState<{ [key: string]: boolean }>({})

  return (
    <div className='w-full mb-6 border border-[#EBF2F2] rounded-[12px] overflow-hidden'>
      <div className='rounded-[12px] flex flex-col gap-[1px] overflow-hidden'>
        {familyFAQs.map((faq, index) => (
          <div
            key={faq.title}
            className={`bg-white ${index === familyFAQs.length - 1 ? '' : 'border-b border-[#EBF2F2]'}`}
          >
            <FAQItem
              key={faq.title}
              titleClassName='!text-[13px] font-[500]'
              title={faq.title}
              description={faq.descp}
              isExpanded={!!accordionState?.[faq.title]}
              onAccordionClick={() => {
                setAccordionState((prev) => ({
                  ...prev,
                  [faq.title]: !prev?.[faq.title]
                }))
              }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
